import { c as _c } from "react/compiler-runtime";
import type { ApiError } from '@onefootprint/request-types/dashboard';
import { InlineAlert } from '@onefootprint/ui';
type ApiErrorAlertProps = {
  error: ApiError;
  hint?: string;
};

// Custom (vs. the standard `useRequestErrorToast`) so a failed vault-data save can surface the error's
// `context` inline: the backend's per-field map of which data identifier failed validation, and why.
export const ApiErrorAlert = t0 => {
  const $ = _c(10);
  const {
    error,
    hint
  } = t0;
  let t1;
  if ($[0] !== error.message) {
    t1 = <span>{error.message}</span>;
    $[0] = error.message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hint) {
    t2 = hint && <span>{hint}</span>;
    $[2] = hint;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== error.context) {
    t3 = error.context && <ul>{Object.entries(error.context).map(_temp)}</ul>;
    $[4] = error.context;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <InlineAlert variant="error"><div className="flex flex-col gap-1 items-start">{t1}{t2}{t3}</div></InlineAlert>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const Json = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  if (typeof data === "string") {
    let t1;
    if ($[0] !== data) {
      t1 = <span>{data}</span>;
      $[0] = data;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== data) {
    t1 = JSON.stringify(data, null, 2);
    $[2] = data;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <code className="text-caption-1">{t1}</code>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(t0) {
  const [key, value] = t0;
  return <li key={key} className="text-start"><strong>{key}: </strong><Json data={value} /></li>;
}